/**
 * Map for license status colors
 * online: green
 * offline: red
 * pending: yellow
 * unassigned: gray
 * inactive: green
 *
 * NOTE: I intentionally made it all lowercase since that's what backend sends
 */
export const LICENSE_STATUS_COLOR_MAP = {
    online: '#3ADB30',
    offline: '#E73535',
};
